import {useFilter} from 'react-aria';
import {useFormContext} from 'react-hook-form';
import {useBackend} from 'state/backend';
import {ActiveTeamMembersFormData} from './types';

/**
 * This hook simplifies and bundles the
 * logic for watching and clearing the search field
 */
export const useSearch = () => {
    const {setValue, watch} = useFormContext();
    const searchQuery = watch('search', '');

    return {
        clearSearch: () => {
            setValue('search', '');
        },
        searchValue: searchQuery,
    };
};

/**
 * This hook simplifies and bundles the logic for
 * filtering the employees based on the search query
 * */
export const useFilterEmployees = () => {
    const {data} = useBackend<ActiveTeamMembersFormData>();

    const {searchValue} = useSearch();

    const {contains} = useFilter({
        sensitivity: 'base',
    });

    return data.employees.filter(
        (employee) =>
            contains(employee.email, searchValue) ||
            contains(employee.name, searchValue),
    );
};
